module.exports = __webpack_public_path__ + "mouse.png?dbc27bee3513bfca401f326c82f6e3b1";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/mouse.png
// module id = 296
// module chunks = 0